import Vue from "vue";
import Vuex from "vuex";

import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

import authentication from "./modules/authentication";
import common from "./modules/common";
import router from "../router"; // vue-router instance
import { sync } from "vuex-router-sync";

Vue.use(Vuex);

export const store = new Vuex.Store({
  getters,
  mutations,
  actions,
  modules: { authentication, common }
});

sync(store, router);
